module.exports = __webpack_public_path__ + "static/media/gaming7.d76dd03d.webp";